import * as React from 'react';
import * as styles from './styles.css';

import { ArticleParagraph1 } from '@cian/ui-kit';

export const ResultReportDescription: React.FC = () => {
  return (
    <div data-testid="ResultReportDescription" className={styles['container']}>
      <ArticleParagraph1>
        Отчет сформирован с помощью сервиса Циан.Оценка. Риелтор уточнил параметры квартиры, исключил некоторые
        объявления из оценки, настроил прогноз и запросил кадастровую стоимость.
      </ArticleParagraph1>
    </div>
  );
};

ResultReportDescription.displayName = 'ResultReportDescription';
